import { useTranslation } from "react-i18next";
import usePaymentHook from "./usePaymentHook";

const usePosSettingsPaymentOptions = () => {
  const { t } = useTranslation();
  const { posPayments } = usePaymentHook();

  return posPayments.map((payment) => ({
    label: t(`posOrders.${payment.translationKey}`),
    value: payment.value,
  }));
};

export default usePosSettingsPaymentOptions;
